import styled from 'styled-components';
import colors from '../../../config/colors.json';
import ScreenSize from '../../../config/screenSizes.json';

export const StyledHeader = styled.div`
    font-size: 28px;
    font-weight: 500;
    line-height: 42px;
    font-family: Poppins, Heltica, Arial, sans-serif;
    color: ${colors.lightGreyMidias};
    margin-bottom: 15px;
`;

export const StyledContainer = styled.div`
    border-radius: 0 0 8px 8px;
    background-color: ${colors.light};
    font-family: Poppins, Heltica, Arial, sans-serif;
`;

export const StyledContainerHeader = styled.div`
    border-radius: 8px 8px 0 0;
    font-size: 20px;
    font-weight: 500;
    line-height: 25px;
    color: ${colors.dark};
    margin-bottom: 32px;
`;

export const StyledContainerContent = styled.div`
    display: flex;
    justify-content: space-between;
    margin-left: 8px;
`;

export const StyledBox = styled.div`
    display: flex;
    flex-wrap: wrap;
    justify-content: space-between;
    padding: 0 24px 0 34px;
    margin-bottom: 32px;
    width: 100%;
    background-color: transparent;
`;

export const StyledBoxSocialMedia = styled.div`
    padding: 32px;
    background-color: ${colors.light};
    border-radius: 8px;
    width: 513px;
    box-shadow: 0 2px 2px ${colors.darkGrey3_15};

    p {
        font-size: 20px;
        font-weight: 500;
        color: ${colors.dark2};
        line-height: 30px;
        margin-bottom: 12px;
        font-family: Poppins, Heltica, Arial, sans-serif;
    }

    .textInfo {
        font-size: 12px;
        color: ${colors.lightGreyMidias};
    }

    span {
        font-size: 12px;
        font-weight: 500;
        color: ${colors.darkGreyMidias2};
        font-family: Poppins, Heltica, Arial, sans-serif;
    }

    img {
        width: 41px;
        height: 41px;
    }

    a {
        background-color: ${colors.redButtons};
        border: none;
        border-radius: 8px; 
        color: ${colors.light};
        font-size: 12px;
        line-height: 18px;
        height: 40px;
        max-width: 177px;
        width: 100%;
        font-weight: bold;
        display: flex;
        justify-content: center;
        align-content: center;
        padding: 11px 0;
        font-family: Poppins, Heltica, Arial, sans-serif;
        &:disabled, button[disabled] {
            opacity: .8;
            cursor: not-allowed;
            background-color: ${colors.lightPink};
            border: ${colors.lightPink};
    }
        &:hover {
            transition: .3s;
            opacity: .8;
            color: ${colors.light}; 
            font-style: normal;
            text-decoration: none;
        }
        &:focus {
            outline: 0;
        }
    }
    @media screen and (min-width: 1920px) {
        max-width: 800px;
        width: calc(50% - 15px);
        a {
            width: 800px;
        }
    }     
 
    @media screen and (max-width: ${ScreenSize.laptop}px) {
        max-width: 800px;
        width: calc(50% - 15px);
        a {
            max-width: 219px;
        }
    }    
    @media screen and (max-width: ${ScreenSize.tabletPlus}px) {
        width: 100%;
        &:last-child {
            margin-left: 0;
        }
        &:first-child {
            margin-bottom: 30px;
        }
        a {
            max-width: 200px;
        }
    }    
    @media screen and (max-width: ${ScreenSize.tablet}px) {
        width: 100%;
        &:last-child {
            margin-left: 0;
        }
        &:first-child {
            margin-bottom: 30px;
        }
        a {
            max-width: 219px;
        }
    }    
    @media screen and (max-width: ${ScreenSize.portrait}px) {
        width: 100%;
        &:last-child {
            margin-left: 0;
            margin-bottom: 0;
        }
        &:first-child {
            margin-bottom: 30px;
        }
        a {
            max-width: 172px;
            margin-left: 0;
        }
    }    
`;

export const StyledIconsCol = styled.div`
    display: flex;
    justify-content: space-between;
    align-items: center;
    width: ${({ bigScreenWidth }) => (bigScreenWidth || '50%')};
    @media screen and (max-width: ${ScreenSize.laptop}px) {
        display: ${({ hideOnSmall }) => (hideOnSmall && 'none')};
        width: ${({ smallScreenWidth }) => (smallScreenWidth || '50%')};
    } 
`;
